import React, { useState } from 'react'

import { Hash } from 'lucide-react'

import { useFocusReturn } from 'Hooks/useFocusReturn'

import { STATUS_COLOR_VAR, STATUS_LABEL } from '../StatusBage'
import { Order } from '../types'
import { deriveOrderStatus, getDisplayId, getItemsSummary, getScheduledLabel } from '../utils'

import { OrderDetailsDialog } from './OrderDetailsDialog'

interface OrderCardProps {
  order: Order
}

export const OrderCard: React.FC<OrderCardProps> = ({ order }) => {
  const [open, setOpen] = useState(false)
  const triggerRef = useFocusReturn<HTMLButtonElement>(open)

  const status = deriveOrderStatus(order)
  const displayId = getDisplayId(order)
  const statusLabel = STATUS_LABEL[status]
  const statusColor = `var(${STATUS_COLOR_VAR[status]})`

  return (
    <article className="user-profile-order-card">
      <button
        ref={triggerRef}
        className="user-profile-order-card__frame user-profile-order-card__trigger"
        style={{ '--status-color': statusColor } as React.CSSProperties}
        type="button"
        onClick={() => setOpen(true)}
      >
        <div className="user-profile-order-card__band">
          <span className="user-profile-order-card__id">
            <Hash aria-hidden size={18} strokeWidth={2} />
            {displayId}
          </span>
          <span className="user-profile-order-card__status-pill">{statusLabel}</span>
          <svg aria-hidden className="user-profile-order-card__wave" preserveAspectRatio="none" viewBox="0 0 200 16">
            <path d="M0,9 C40,16 60,0 100,7 C140,14 160,2 200,8 L200,16 L0,16 Z" />
          </svg>
        </div>
        <div className="user-profile-order-card__face-body">
          <p className="user-profile-order-card__meta">
            {[getScheduledLabel(order), getItemsSummary(order)].filter(Boolean).join(' · ')}
          </p>
          <div className="user-profile-order-card__price-row">
            <span className="user-profile-order-card__price-label">Total</span>
            <span className="user-profile-order-card__price">{order.totalMoneyFormatted}</span>
          </div>
        </div>
      </button>

      <OrderDetailsDialog open={open} order={order} onOpenChange={setOpen} />
    </article>
  )
}
